import React, {useContext, useMemo} from 'react';
import {Layout, Row, Col} from 'antd'

import AuthService from './../../services/AuthService';
import {UserContext} from '../../context';
import {logout, removeCurrentBranchUuId, getCurrentBranchUuId} from '../../helpers/token';
import UserActions from './UserActions';
import logo from '../../logo.svg';

import './index.scss';

const { Header: AntHeader } = Layout;

const Header = () => {

    const user = useContext(UserContext);
    const branchName = useMemo(() => {
        return user.branches.find(branch => branch.uuId === getCurrentBranchUuId()).name;
    }, []);

    const _logout = () => {
        AuthService.logout().then(({}) => {
            logout();
        });
    };

    const changeBranch = () => {
        removeCurrentBranchUuId();
        window.location.reload();
    };
    return (
        <AntHeader className='main-header'>
            <Row type='flex' justify='space-between'>
                <Col>
                    <img width={98} src={logo} alt='logo'/>
                </Col>
                <Col>
                    <UserActions
                      showBranch={user.branches.length > 1}
                      name={`${user.firstName} ${user.lastName}`}
                      branchName={branchName}
                      changeBranch={changeBranch}
                      logout={_logout}
                    />
                </Col>
            </Row>
        </AntHeader>
    )
};

export default Header;